import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
  Grid,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { isDesktop } from "../../../utils/utils";
import Event1 from "./event1";
import video from "../../../public/videos/satrang_sponsorship.mp4";

const Satrang25 = () => {
  const openNewTab = (link) => {
    window.open(link);
  };

  const isDesktopView = isDesktop();

  return (
    <Accordion sx={{ mt: 5 }} defaultExpanded>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography variant="h4">SatRang Theatre 2025</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          {/* <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={satrang24Poster}
              alt="satrang24"
              style={{
                width: "100%",
                height: isDesktopView ? '500px' :"100%",
                objectFit: "contain",
              }}
            />
          </Box>
          <Typography variant="h4">Acts for this year</Typography> */}
          <Grid container>
            <Stack
              sx={{
                p: 1,
                display: "inherit",
                width: "100%",
                alignItems: "center",
                height: "fit-content",
              }}
            >
              <video
                src={video}
                style={{
                  width: isDesktopView ? "50%" : "100%",
                  height: isDesktopView ? "50%" : "100%",
                }}
                controls
              ></video>
            </Stack>
            <Grid item xs={12} sx={{ p: 1 }}>
              <Event1 openNewTab={openNewTab} />
            </Grid>
          </Grid>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default Satrang25;
